<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-A">Contents </p>
<p class="p-content1"><a href="#/foreword">FOREWORD BY VICTORIA OSTEEN</a></p>
<p class="p-content1"><a href="#/introduction">INTRODUCTION</a></p>
<div class="illustration"><img alt="" height="21" src="images/img2.jpg" width="35"/></div>
<p class="p-content2"><a href="#/chapter1">CHAPTER ONE</a></p>
<p class="p-content3"><a href="#/chapter1">Overview</a></p>
<p class="p-content2"><span href="#/chapter2" title="Link target outside of Sample">CHAPTER TWO</span></p>
<p class="p-content3"><span href="#/chapter2" title="Link target outside of Sample">Bishop T. D. and Serita Jakes</span></p>
<p class="p-content2"><span href="#/chapter3" title="Link target outside of Sample">CHAPTER THREE</span></p>
<p class="p-content3"><span href="#/chapter3" title="Link target outside of Sample">Pastors Joel and Victoria Osteen</span></p>
<p class="p-content2"><span href="#/chapter4" title="Link target outside of Sample">CHAPTER FOUR</span></p>
<p class="p-content3"><span href="#/chapter4" title="Link target outside of Sample">Pastors Samuel and Eva Rodriguez</span></p>
<p class="p-content2"><span href="#/chapter5" title="Link target outside of Sample">CHAPTER FIVE</span></p>
<p class="p-content3"><span href="#/chapter5" title="Link target outside of Sample">Rev. Mike and Jeannie Glenn</span></p>
<p class="p-content2"><span href="#/chapter6" title="Link target outside of Sample">CHAPTER SIX</span></p>
<p class="p-content3"><span href="#/chapter6" title="Link target outside of Sample">Rev. Martin Lam Nguyen, CSC</span></p>
<p class="p-content2"><span href="#/chapter7" title="Link target outside of Sample">CHAPTER SEVEN</span></p>
<p class="p-content3"><span href="#/chapter7" title="Link target outside of Sample">Rev. Dr. Ed and Jo Beth Young</span></p>
<p class="p-content2"><span href="#/chapter8" title="Link target outside of Sample">CHAPTER EIGHT</span></p>
<p class="p-content3"><span href="#/chapter8" title="Link target outside of Sample">Rev. Randy and Rozanne Frazee</span></p>
<p class="p-content2"><span href="#/chapter9" title="Link target outside of Sample">CHAPTER NINE</span></p>
<p class="p-content3"><span href="#/chapter9" title="Link target outside of Sample">Rev. Kirbyjon and Pastor Suzette Caldwell</span></p>
<p class="p-content2"><span href="#/chapter10" title="Link target outside of Sample">CHAPTER TEN</span></p>
<p class="p-content3"><span href="#/chapter10" title="Link target outside of Sample">Pastors Matthew and Caroline Barnett</span></p>
<p class="p-content2"><span href="#/chapter11" title="Link target outside of Sample">CHAPTER ELEVEN</span></p>
<p class="p-content3"><span href="#/chapter11" title="Link target outside of Sample">Rev. Dr. Jim and Barb Dixon</span></p>
<p class="p-content2"><span href="#/chapter12" title="Link target outside of Sample">CHAPTER TWELVE</span></p>
<p class="p-content3"><span href="#/chapter12" title="Link target outside of Sample">Rev. George and Joan Foreman</span></p>
<p class="p-content2"><span href="#/chapter13" title="Link target outside of Sample">CHAPTER THIRTEEN</span></p>
<p class="p-content3"><span href="#/chapter13" title="Link target outside of Sample">Pastors Ron and Hope Carpenter</span></p>
<p class="p-content2"><span href="#/chapter14" title="Link target outside of Sample">CHAPTER FOURTEEN</span></p>
<p class="p-content3"><span href="#/chapter14" title="Link target outside of Sample">Revs. Drs. Floyd and Elaine Flake</span></p>
<p> </p>
<div class="illustration"><img alt="" height="21" src="images/img2.jpg" width="35"/></div>
<p class="p-content1"><span href="#/chapter14#a1" title="Link target outside of Sample">THANKS</span></p>
<p class="p-content1"><span href="#/metric" title="Link target outside of Sample">METRIC CONVERSIONS AND EQUIVALENTS</span></p>
<p class="p-content1"><span href="#/index" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?1f629c17